import "./SubmitActionOperations.less";
import {
    ScoringModeButtonSet,
    RescoreModeButtonSet,
    AgentModeButtonSet,
} from "./ButtonSets";
import { selectIsScorableInReview } from "features/scorable/scorableSlice";
import { useAppSelector } from "app/hooks";
import { SideDrawerMode } from "enums/SideDrawerMode";
import { SubmitActionNotices } from "./SubmitActionNotices";
import { selectSubmitNotices } from "features/scorable/scorableSlice";
import { ReleaseDateSelectedType } from "features/qualityForm/formViewer/footer/releaseEvaluationTime/ReleaseEvaluationSelector";

export interface SubmitActionOperationsProps {
    isCompleted: boolean;
    rescoreMode: boolean;
    toggleRescoreMode: () => void;
    calibrationMode: boolean;
    isAdmin: boolean;
    attemptSubmit: () => void;
    attemptSubmitAndAssign?: () => void;
    attemptSave: () => void;
    attemptSaveByAgent?: () => void;
    attemptDispute?: () => void;
    attemptDisputeByAgent?: () => void;
    attemptDisputeDecline?: () => void;
    calibrationError: (response: string) => void;
    toggleCalibrationMode?: () => void;
    setSideDrawerMode: React.Dispatch<React.SetStateAction<SideDrawerMode>>;
    releaseDateData?: ReleaseDateSelectedType;
}

export function SubmitActionOperations({
    isCompleted,
    rescoreMode,
    toggleRescoreMode,
    calibrationMode,
    isAdmin,
    attemptSubmit,
    attemptSubmitAndAssign,
    attemptSave,
    attemptSaveByAgent,
    attemptDispute,
    attemptDisputeByAgent,
    attemptDisputeDecline,
    calibrationError,
    toggleCalibrationMode,
    setSideDrawerMode,
    releaseDateData,
}: SubmitActionOperationsProps) {
    const isStatusInReview = useAppSelector(selectIsScorableInReview);
    const showAgentModeButtonSet = isCompleted && !isAdmin && !isStatusInReview;
    const showRescoreModeButtonSet = isCompleted && isAdmin;
    const showScoringModeButtonSet = !isCompleted;

    const submitNotices = useAppSelector((state) =>
        selectSubmitNotices(state, {
            isAdmin,
            attemptDispute: !!attemptDispute,
            attemptDisputeDecline: !!attemptDisputeDecline,
        })
    );

    const hasSubmitNotices = submitNotices.length > 0;
    return (
        <>
            {hasSubmitNotices && (
                <SubmitActionNotices
                    submitNotices={submitNotices}
                    isAdmin={isAdmin}
                />
            )}
            <div
                className={`SubmitActionOperations${
                    hasSubmitNotices
                        ? ` Button${isAdmin ? "Admin" : "Agent"}Notice`
                        : ""
                }`}
            >
                {showRescoreModeButtonSet && (
                    <RescoreModeButtonSet
                        calibrationMode={calibrationMode}
                        calibrationError={calibrationError}
                        toggleCalibrationMode={toggleCalibrationMode}
                        toggleRescoreMode={toggleRescoreMode}
                        setSideDrawerMode={setSideDrawerMode}
                        attemptDispute={attemptDispute}
                        attemptDisputeDecline={attemptDisputeDecline}
                    ></RescoreModeButtonSet>
                )}
                {showScoringModeButtonSet && (
                    <ScoringModeButtonSet
                        isAdmin={isAdmin}
                        rescoreMode={rescoreMode}
                        toggleRescoreMode={toggleRescoreMode}
                        attemptSave={attemptSave}
                        attemptSubmit={attemptSubmit}
                        attemptSubmitAndAssign={attemptSubmitAndAssign}
                        setSideDrawerMode={setSideDrawerMode}
                        releaseDateData={releaseDateData}
                    ></ScoringModeButtonSet>
                )}
                {showAgentModeButtonSet && (
                    <AgentModeButtonSet
                        attemptSaveByAgent={attemptSaveByAgent}
                        attemptDisputeByAgent={attemptDisputeByAgent}
                    ></AgentModeButtonSet>
                )}
            </div>
        </>
    );
}
